import { render, staticRenderFns } from "./CandidateProfileHeader.vue?vue&type=template&id=36fee04c&scoped=true&"
import script from "./CandidateProfileHeader.vue?vue&type=script&lang=ts&"
export * from "./CandidateProfileHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateProfileHeader.vue?vue&type=style&index=0&id=36fee04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fee04c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
